import { PropsWithChildren } from 'react';

import { cx } from 'libs/ui/theme';

import { Header } from './Header';
import { LayoutStyled, LayoutStyledProps } from './Layout.styles';
import { WrapperStyled } from './Wrapper.styles';
import { LayoutClasses } from './types';

export interface LayoutProps extends LayoutStyledProps {
  className?: string;
}

export const Layout = ({
  children,
  backgroundVariant,
  className,
}: LayoutProps & PropsWithChildren) => (
  <LayoutStyled
    backgroundVariant={backgroundVariant}
    className={cx(LayoutClasses.main.name, className)}
  >
    <Header className={LayoutClasses.header.name} />
    <WrapperStyled as="main" className={LayoutClasses.content.name}>
      {children}
    </WrapperStyled>
    <footer className={LayoutClasses.footer.name} />
  </LayoutStyled>
);

Layout.classes = LayoutClasses;
